var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentItem',{attrs:{"name":_vm.name}},[_c('Dropdown',{style:('width:100%;'),attrs:{"items":_vm.time.timeFields,"selected":_vm.selectedTime},on:{"change":_vm.select}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }